import React, { FC } from 'react';
import { Form } from 'semantic-ui-react'
import { ManualDiscountMode } from '../../../interfaces/manualDiscount';

interface ManualDiscountDropDownProps {
  value: ManualDiscountMode;
  tenantDefault: boolean;
  onChange: (value: ManualDiscountMode) => void;
}

const hints: Record<ManualDiscountMode, string> = {
  default: 'Übernimmt die Einstellung des Mandanten, auch wenn sie sich später ändert.',
  on: 'Überschreibt den Mandanten: Betragsfeld wird immer angezeigt.',
  off: 'Überschreibt den Mandanten: nur Schnellbuttons, keine manuelle Eingabe.',
};

export const ManualDiscountDropDown: FC<ManualDiscountDropDownProps> = ({ value, tenantDefault, onChange }) => {
  const options = [
    {
      key: 'default',
      text: `Standard des Mandanten (${tenantDefault ? 'erlaubt' : 'nicht erlaubt'})`,
      value: 'default',
    },
    { key: 'on', text: 'Erlaubt', value: 'on' },
    { key: 'off', text: 'Nicht erlaubt', value: 'off' },
  ];

  return (
    <Form.Field>
      <Form.Dropdown
        fluid
        label='Manuelle Betragseingabe'
        selection
        options={options}
        value={value}
        onChange={(e: any, { value }: any) => onChange(value)}
        style={{ marginTop: 4 }}
      />
      <div style={{ marginTop: '0.5em', color: 'rgba(0, 0, 0, 0.6)', fontSize: '0.9em' }}>{hints[value]}</div>
    </Form.Field>
  );
};
